"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withOnMailLightTheme = withOnMailLightTheme;
exports.withOnMailDarkTheme = withOnMailDarkTheme;
exports.ForceOnMailDarkTheme = exports.InheritedTheme = exports.OnMailThemeProvider = exports.OnMailThemeContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _materialUi = require("../material-ui.theme");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _constants = require("../utils/constants");

var OnMailThemeContext = /*#__PURE__*/(0, _react.createContext)({
  mode: _constants.themeMode.LIGHT,
  setAutoTheme: function setAutoTheme() {},
  setDarkTheme: function setDarkTheme() {},
  setLightTheme: function setLightTheme() {}
});
exports.OnMailThemeContext = OnMailThemeContext;

var OnMailThemeProvider = function OnMailThemeProvider(_ref) {
  var children = _ref.children,
      preferredMode = _ref.mode,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "mode"]);

  var _useState = (0, _react.useState)(preferredMode === _constants.themeMode.DARK ? _constants.themeMode.DARK : _constants.themeMode.LIGHT),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _materialUi.createTheme)(_constants.themeMode.DARK)),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      muiTheme = _useState4[0],
      setMuiTheme = _useState4[1];

  (0, _react.useEffect)(function () {
    if (preferredMode && (preferredMode === _constants.themeMode.DARK || preferredMode === _constants.themeMode.LIGHT)) {
      setMode(preferredMode);
    }
  }, [preferredMode]);
  (0, _react.useEffect)(function () {
    (0, _utils.setTheme)(mode);
    setMuiTheme((0, _materialUi.createTheme)(mode));
  }, [mode]);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      mode: mode,
      setDarkTheme: function setDarkTheme() {
        return setMode(_constants.themeMode.DARK);
      },
      setLightTheme: function setLightTheme() {
        return setMode(_constants.themeMode.LIGHT);
      }
    };
  }, [mode]);
  return /*#__PURE__*/_react["default"].createElement(OnMailThemeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: muiTheme
  }, children));
}; // For the popup components that want to use different theme from the main document


exports.OnMailThemeProvider = OnMailThemeProvider;

var InheritedTheme = function InheritedTheme(_ref2) {
  var children = _ref2.children;

  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette;

  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-theme": palette.type,
    className: (0, _classnames["default"])('text-medium', {
      dark: palette.type === _constants.themeMode.DARK
    })
  }, children);
};

exports.InheritedTheme = InheritedTheme;

var ForceThemeProvider = function ForceThemeProvider(_ref3) {
  var children = _ref3.children,
      mode = _ref3.mode;
  var muiTheme = (0, _react.useMemo)(function () {
    return (0, _materialUi.createTheme)(mode || _constants.themeMode.LIGHT);
  }, [mode]);

  if (mode && (mode === _constants.themeMode.DARK || mode === _constants.themeMode.LIGHT)) {
    var contextValue = {
      mode: mode,
      setDarkTheme: function setDarkTheme() {
        return console.error("Unexpected operation. The component was forced to set the theme as ".concat(mode, "."));
      },
      setLightTheme: function setLightTheme() {
        return console.error("Unexpected operation. The component was forced to set the theme as ".concat(mode, "."));
      }
    };
    return /*#__PURE__*/_react["default"].createElement(OnMailThemeContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
      theme: muiTheme
    }, /*#__PURE__*/_react["default"].createElement(InheritedTheme, null, children)));
  } else {
    return children;
  }
};

function withOnMailLightTheme(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(ForceThemeProvider, {
      mode: _constants.themeMode.LIGHT
    }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, props));
  };
}

function withOnMailDarkTheme(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(ForceThemeProvider, {
      mode: _constants.themeMode.DARK
    }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, props));
  };
}

var ForceOnMailDarkTheme = function ForceOnMailDarkTheme(_ref4) {
  var children = _ref4.children,
      enable = _ref4.enable;
  var Wrapper = (0, _react.useMemo)(function () {
    return enable ? withOnMailDarkTheme(_react["default"].Fragment) : _react["default"].Fragment;
  }, [enable]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, children);
};

exports.ForceOnMailDarkTheme = ForceOnMailDarkTheme;
//# sourceMappingURL=theme.js.map